import { render, staticRenderFns } from "./generalCommunication.vue?vue&type=template&id=189fdaf8"
import script from "./generalCommunication.vue?vue&type=script&lang=js"
export * from "./generalCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189fdaf8')) {
      api.createRecord('189fdaf8', component.options)
    } else {
      api.reload('189fdaf8', component.options)
    }
    module.hot.accept("./generalCommunication.vue?vue&type=template&id=189fdaf8", function () {
      api.rerender('189fdaf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/mail/generalCommunication.vue"
export default component.exports